import cx from 'classnames';
import React, { Children } from 'react';
import * as classes from 'src/components/LandingPage/ServicePlans/ServicePlans.module.scss';

export const PlanNavigation = ({ plans, onPlanSelect, currentPlanIndex }) => (
  <div className={classes.navigationContainer}>
    {Children.toArray(
      plans.map((_, i) => (
        <button
          type="button"
          onClick={() => onPlanSelect(i)}
          className={cx({
            [classes.navigationButton]: true,
            [classes.navigationButtonActive]: i === currentPlanIndex,
          })}
          aria-label={`Select plan ${plans[i].name}`}
        />
      ))
    )}
  </div>
);
